import { render, staticRenderFns } from "./FamilyDataInfoNotes.vue?vue&type=template&id=0b3e1c35&scoped=true&"
import script from "./FamilyDataInfoNotes.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataInfoNotes.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataInfoNotes.vue?vue&type=style&index=0&id=0b3e1c35&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e1c35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
